import { AbstractControl, ValidationErrors, ValidatorFn } from '@angular/forms';
import { Injectable } from '@angular/core';

@Injectable({
    providedIn: 'root',
})
export class MarktpartnerValidator {

    public static readonly PATTERN = new RegExp('^(([4-5]\\d)|60|99)\\d{11}$');
    public static readonly SEPARATOR = ',';

    static validateSingle(): ValidatorFn {
        return (control: AbstractControl): ValidationErrors | null => {
            if (!control.value) {
                return null;
            }

            if (!control.value || !control.value.toString().match(MarktpartnerValidator.PATTERN)) {
                return { pattern: true };
            }

            return null;
        };
    }

    static validateMultiple(maxAmount: number = null): ValidatorFn {
        return (control: AbstractControl): ValidationErrors | null => {
            if (!control.value) {
                return null;
            }

            let values = control.value.toString()
                .split(MarktpartnerValidator.SEPARATOR) //split singe string to array
                .filter(value => value); // filter empty

            if (maxAmount !== null && values.length > maxAmount) {
                return { length: true };
            }

            values = values
                .map(value => !value.match(MarktpartnerValidator.PATTERN)) // validate all values
                .filter(value => value); // filter only invalid

            if (values.length > 0) {
                return { pattern: true };
            }

            return null;
        };
    }
}


